export const displayLogs = process.env.NODE_ENV === 'development';
